export default class {
    constructor(id, date, title, type = 'text', item = null) {
        this.id = id
        this.date = date
        this.title = title
        this.type = type
        this.item = item
    }
}
